"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.answerSchema = exports.userAnswerSchema = exports.answerBaseSchema = void 0;
const zod_1 = require("zod");
const userInteractionAssessment_1 = require("../../userInteractionAssessment");
const base_1 = require("../base");
exports.answerBaseSchema = zod_1.z.object({
    kind: zod_1.z.literal("answer"),
    isCorrect: zod_1.z.boolean().nullable(),
    userAnswer: zod_1.z.string(),
    correctAnswer: zod_1.z.string(),
    audioURL: zod_1.z.string().optional(),
    replyInteractionId: zod_1.z.string(),
});
exports.userAnswerSchema = zod_1.z
    .object({
    assessment: userInteractionAssessment_1.userInteractionCompleteAssessmentSchema
        .pick({ score: true })
        .and(zod_1.z.object({
        pronunciation: userInteractionAssessment_1.userInteractionPronunciationAssessmentSchema.nullish(),
        answer: userInteractionAssessment_1.userInteractionAnswerAssessmentSchema,
    }))
        .nullable(),
})
    .merge(exports.answerBaseSchema)
    .merge(base_1.sessionInteractionBaseSchema.extend({ from: zod_1.z.literal("user") }));
exports.answerSchema = exports.userAnswerSchema;
//# sourceMappingURL=answer.js.map